/* global graphql  */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import PressItem from '../components/press-item'

class PressPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      theme: 'dark',
      pressToShow: [],
      limit: 6
    }

    this.handleViewMore = this.handleViewMore.bind(this)
    this.setTheme = this.setTheme.bind(this)
  }

  componentDidMount () {
    const pressToShow = this.props.data.allDrupalPress
      .edges
      .slice(0, this.state.limit)
    this.setState({ pressToShow })
    document.addEventListener('scroll', this.setTheme)
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.setTheme)
  }

  setTheme () {
    const pressBody = document.querySelector('.press__body')
    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1024

    if (isDesktop && pressBody.getBoundingClientRect().top <= 164) {
      this.setState({ theme: 'light' })
    } else {
      this.setState({ theme: 'dark' })
    }
  }

  handleViewMore () {
    const pressToShow = this.props.data.allDrupalPress
      .edges
      .slice(0, this.state.pressToShow.length + this.state.limit)
    this.setState({ pressToShow })
  }

  render () {
    const { theme, pressToShow, limit } = this.state
    const { data: { drupalMedia, allDrupalPress } } = this.props

    return (
      <div className='wrapper--page page--press'>
        <Helmet title='Press - ATTN:' />
        <Header theme={theme} />
        <div className='press__hero'>
          <img
            className='press__hero--desktop'
            src={drupalMedia.image_desktop.url}
          />
          <img
            className='press__hero--mobile'
            src={drupalMedia.image_mobile.url}
          />
        </div>
        <div className='press__body'>
          <div className='press__items'>
            {pressToShow.map(({ node }) => (
              <PressItem
                press={node}
                key={node.id}
              />
            ))}
          </div>
          {allDrupalPress.edges.length > limit && pressToShow.length < allDrupalPress.edges.length
            ? <div className='press__view-btn'>
              <span onClick={this.handleViewMore}>View more</span>
            </div>
            : null
          }
        </div>
        <Footer />
      </div>
    )
  }
}

PressPage.propTypes = {
  data: PropTypes.object
}

export default PressPage

export const query = graphql`
  query PressPage {
    drupalMedia(pid: {eq: "91"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
    }
    allDrupalPress(sort: {fields: [date___value], order: DESC}) {
      edges {
        node {
          id
          headline
          source
          cta {
            url {
              path
            }
          }
          image {
            url
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/press.js